export default __webpack_public_path__ + "static/media/gallery-wip-clamp-lever_20.1591ef07.jpg";